import React, {useEffect, useState} from 'react';
import {LinkName, TopNav} from "../UiParts/TopNav";
import {SimulationBaseTable} from "./SimulationBaseTable/SimulationBaseTable";
import {SimulationHeaderButtons} from "./HeaderButtons/SimulationHeaderButtons";
import {changeDateStyle, createBlankData, createDateList, loadLocalStorage, randomStr} from "./simulationFunctions";
import Explained from "./Explained";
import {SimulationData} from "./simulationTypes";
import {RuleType} from "./RuleType";

type Props = {
  selectedPage: string,
  setSelectedPage: React.Dispatch<React.SetStateAction<LinkName>>;
  rule: RuleType;
}

export const Simulation: React.VFC<Props> = (props) => {
  const nowDay = new Date();
  const nowDayStr = nowDay.toLocaleDateString();
  const [simulations, setSimulations] = useState<SimulationData[]>([createBlankData(randomStr(12), props.rule)]);
  const [dateStr, setDateStr] = useState<string>(changeDateStyle(nowDayStr));
  const [dateList, setDateList] = useState<string[]>(createDateList(nowDayStr));

  useEffect(()=> {
    // ルールを切り替えた際にID表記を切り替えて空データを作る
    setSimulations([createBlankData(randomStr(12), props.rule)]);
    // 保存データをチェックして反映させる
    const {simulations, date, dateList} = loadLocalStorage(props.rule);
    if (simulations && date && dateList) {
      setDateStr(date);
      setDateList(JSON.parse(dateList));
      setSimulations(JSON.parse(simulations));
    }
  }, [props.rule]);

  return (
    <div className="h-full bg-cover bg-[url('https://images.unsplash.com/photo-1521941651707-748bdbae77e9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80')]">
      <div className="h-full bg-white opacity-95">
        <TopNav selectedPage={props.selectedPage} setSelectedPage={props.setSelectedPage} />
        <SimulationHeaderButtons
          dateStr={dateStr}
          setDateStr={setDateStr}
          dateList={dateList}
          setDateList={setDateList}
          simulations={simulations}
          setSimulations={setSimulations}
          rule={props.rule}
        />
        <h2>適用ルール：
          {props.rule === RuleType.young && 'ヤング'}
          {props.rule === RuleType.littleSenior && 'リトルシニア'}
          {props.rule === RuleType.junior && 'ジュニア'}
        </h2>
        <SimulationBaseTable
          dateStr={dateStr}
          setDateStr={setDateStr}
          dateList={dateList}
          setDateList={setDateList}
          simulations={simulations}
          setSimulations={setSimulations}
          rule={props.rule}
        />
        <Explained />
      </div>
    </div>
  );
};
